'use client';

import { ObjectRawData } from '@components/PreCartInternalTools/ObjectRawData/ObjectRawData';
import { Flex, Switch, Typography } from '@coolblue-development/freddy';
import { NodeInputProps, NodeProps } from '@features/article/types';
import { useState } from 'react';

export const ArticleRawData = ({
  node,
  nodeInput
}: {
  node: NodeProps;
  nodeInput?: NodeInputProps;
}) => {
  const [expand, setExpand] = useState(false);
  const [checked, setChecked] = useState(false);

  function onSwitch() {
    setChecked(!expand);
    setExpand(!expand);
  }

  const object = {
    ...node,
    nodeInput
  };

  return (
    <>
      <Flex justifyContent='space-between'>
        <Typography variant='h2' mb={300}>
          Sitemap node and article
          <Typography fontSize='sm' mb={0} ml={200} color='interactiveSubtle' display='inline'>
            data for developers
          </Typography>
        </Typography>
        <Switch
          label={checked ? 'Collapse data' : 'Expand data'}
          checked={checked}
          onChange={onSwitch}
        />
      </Flex>
      <ObjectRawData key={`${expand}`} obj={object} startExpended={expand} />
    </>
  );
};
